export const isInternalAccess = (userRole: string) => {
    return ["admin", "sales" ].includes(userRole) 
}

export const isExternalAcces = (userRole: string) => {
    return ["admin", "sales" , "canvasser"].includes(userRole)
}